import { getPlusViewURL } from './configurationUrl.js';
const config = {
    MAS_TGC_UAT: '',
    singlePointLogin: '',
    appId: '',
    staffSelector: {},
    defaultPage: '',
    uploadAppId: '',
    uploadAppKey: '',
    volacnoBasePointAPPID: 10000434,
    env: 'PROD'
};
if (process.env.VUE_APP_ENV) {
    config.MAS_TGC = process.env.VUE_APP_MAS_TGC;
    config.MIDEA_SYSTEM = process.env.VUE_APP_MIDEA_SYSTEM;
    config.LOGIN_MIDEA_URL = process.env.VUE_APP_LOGIN_MIDEA_URL;
    config.domain = process.env.VUE_APP_DOMAIN;
    config.singlePointLogin = process.env.VUE_APP_LOGIN_URL;
    config.staffSelector = {
        url: process.env.VUE_APP_STAFF_SELECTOR_URL,
        project: process.env.VUE_APP_STAFF_SELECTOR_PROJECT
    };
    config.appId = process.env.VUE_APP_APPID;
    config.defaultPage = process.env.VUE_APP_DEFAULT_PAGE;
    config.uploadAppId = process.env.VUE_APP_UPLOAD_APP_ID;
    config.uploadAppKey = process.env.VUE_APP_UPLOAD_APP_KEY;
    config.apiUrl = process.env.VUE_APP_API_URL;
    config.env = process.env.VUE_APP_ENV;
    // 大数据埋点配置参数
    config.bigDataLogTokenUrl = process.env.VUE_APP_BIG_DATA_LOG_TOKEN_URL;
    config.bigDataLogUrl = process.env.VUE_APP_BIG_DATA_LOG_URL;
    config.bigDataLogAppSecrect = process.env.VUE_APP_BIG_DATA_LOG_APP_SECRECT;
    config.bigDataLogAppName = process.env.VUE_APP_BIG_DATA_LOG_APP_NAME;
    // 融合组件环境区分
    config.robotEnvironment = process.env.VUE_APP_ROBOTENVIRONMENT;
    config.volacnoBasePointAPPID = process.env.VUE_APP_VOLACNO_BASE_POINT_APPID;
    config.microPlusViewURL = getPlusViewURL(process.env.VUE_APP_ENV);
} else {
    config.MAS_TGC = 'midea_auth_uat';
    config.MIDEA_SYSTEM = 'https://permuat.midea.com/flows/#/permission/100317';
    config.LOGIN_MIDEA_URL = '//signinuat.midea.com/logout?service=';
    config.domain = '.midea.com';
    config.singlePointLogin = '//localhost.midea.com:8080/sn-login.html?service=';
    config.staffSelector = {
        url: 'http://devcloud.midea.com/builder/m_staff_selector-V1.0.1/index.js',
        project: '/mframework'
    };
    config.appId = 'MFRAMEWORK_CLI3.0';
    config.defaultPage = '/index.html';
    config.uploadAppId = '32883248FE8946CCA59DDB36C80BF571';
    config.uploadAppKey = 'Vgjmcgy24Hjwb6Buq7ZfRz0uX2NebGJFrfYDRRPZ';
    config.apiUrl = '/';
    config.bigDataLogTokenUrl = '//apisit.midea.com/bigds/token/bigdatatoken/';
    config.bigDataLogUrl = '//apisit.midea.com/bigds/maidian';
    config.bigDataLogAppSecrect = '12dkg-aklk1j-nh9o1-12ju-aj1ai1vsd';
    config.bigDataLogAppName = 'C-SNP';
    config.robotEnvironment = 'uat';
    config.microPlusViewURL = getPlusViewURL(process.env.VUE_APP_ENV);
}

export default config;
